import { signal } from '@angular/core';

import { Seite } from './Seite';

export class Beleg {
  private readonly _belegSeiten = signal<Seite[]>([]);
  private _belegType!: BelegType;

  constructor() {
    this.belegType = BelegType.NOT_SET;
  }

  public get belegType(): BelegType {
    return this._belegType;
  }

  public set belegType(belegType: BelegType) {
    this._belegType = belegType;
  }

  public get seiten(): Seite[] {
    return this._belegSeiten();
  }

  public switchSeite(seite: Seite): void {
    const currentSeiten = this._belegSeiten();
    const indexToSwitch = currentSeiten.indexOf(seite);
    currentSeiten[indexToSwitch] = seite;
    this._belegSeiten.set([...currentSeiten]);
  }

  public addSeite(seite: Seite): void {
    this._belegSeiten.set([...this._belegSeiten(), seite]);
  }

  public clearBelegType(): void {
    this._belegType = BelegType.NOT_SET;
  }

  public getBelegSize(): Promise<number> {
    return this._belegSeiten().reduce(
      async (nextValue, currentValue) => (await nextValue) + (await currentValue.getSize()),
      Promise.resolve(0),
    );
  }

  public removeSeite(seite: Seite): void {
    this._belegSeiten.set(this._belegSeiten().filter((_seite) => _seite !== seite));
  }
}

export enum BelegType {
  NOT_SET,
  UNFALL_BELEG,
}
